import Container from "@/components/Container";
import LeadForm from "@/components/LeadForm";

const TRADES = ["contractor","designer","architect","surveyor","estate_agent","trade_other"];

export default function WorkWithUs() {
  return (
    <div className="pt-36 pb-32">
      <Container className="grid grid-cols-1 lg:grid-cols-12 gap-16 lg:gap-24">
        <div className="lg:col-span-5">
          <div className="flex items-center gap-4 mb-10">
            <span className="label-mono">No. 08 — The Register</span>
            <span className="h-px w-10 bg-ruby" />
          </div>
          <h1 className="serif-display text-5xl md:text-6xl lg:text-[6.5rem] text-ink-700">
            Trades,<br />
            designers,<br />
            <span className="serif-italic text-ruby">specialists.</span>
          </h1>
          <p className="mt-10 text-ink-400 leading-[1.8] text-base lg:text-lg max-w-lg">
            Join the Rubys.Group register of trusted specialists. We engage long-term, pay on time, and protect the standard of every finish that bears our name.
          </p>
        </div>
        <div className="lg:col-span-7">
          <LeadForm
            leadType="contractor"
            sourcePage="/work-with-us"
            title="Join the Rubys register"
            fields={["name","email","phone","company","message"]}
            extra={[{ name: "discipline", label: "Discipline", options: TRADES }]}
            submitLabel="Submit Application"
          />
        </div>
      </Container>
    </div>
  );
}
